export default class SendJobsToWorkerRequest  { 
    jobIds: string[] = [];
    isTest = false;
    testEmailAddresses = '';
    // emailSubject: string = '';
    // emailOpeningParagraph: string = '';
    // emailClosingParagraph: string = '';	
}
